import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'mg-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  @Input() exportTitle = 'Export to CSV'
  @Input() extraClass = ''
  @Input() showNumberOfRows = true
  @Input() numberOfRows = 0
  @Input() isLoading = false
  @Input() showDownloadButton = true
  @Output() exportBtnClicked = new EventEmitter()
}
